import { createContext } from 'react'
import { IContextType } from './model'

const initialState: IContextType = {
  title: {
    name: 'All Time',
    value: '',
  },
  setFilters() {
    return null
  },
  handleOptionChange(e) {
    return null
  },
  selectedOption: 'first',
  search: '',
  sortBy: '',
  setSortBy() {
    return null
  },
  sortDirection: 'asc',
  setSortDirection() {
    return null
  },
}

export const CustomStore = createContext<IContextType>(initialState)
